import { render, staticRenderFns } from "./EditarNovedadDialogComponent.vue?vue&type=template&id=58b4ccbb"
import script from "./EditarNovedadDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarNovedadDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports